export const ROLE = [
  { Administrator: "66260555cbc06e1b61aac414" },
  { Writer: "66260511cbc06e1b61aac411" },
  { Reviewer: "66260532cbc06e1b61aac412" },
  { Publisher: "66260546cbc06e1b61aac413" },
  { ReadOnly: "6644b416d890eebfe93113e4" },
  { Translator : "664758d55e2ec571f3373e55" },
  { SuperAdministrator : "66615cc0d4715f5c2da5e4d0" }
];
